/**
 * FT20-U43 (FSD 3.2.4.10, R061): the Treasury KPI dashboard.
 *
 * The router spreads `TREASURY_KPI_ROUTES`; nav id `treasury-kpis` (section s-3.2.4)
 * points here. Reading is `treasury.kpi.read`, the permission of
 * `GET /reports/treasury-kpis` (`treasury/report_permissions.go PermKPIRead`).
 */

import type { RouteRecordRaw } from 'vue-router'

export const TREASURY_KPI_PERMISSION = 'treasury.kpi.read'

export const TREASURY_KPIS_PATH = '/treasury/reports/kpis'

export const TREASURY_KPI_ROUTES: RouteRecordRaw[] = [
  {
    path: '/treasury/reports/kpis',
    name: 'treasury-kpis',
    component: () => import('@/modules/treasury/reports/kpis/TreasuryKpiDashboardView.vue'),
    meta: { titleKey: 'treasury.kpis.routeTitle', permission: TREASURY_KPI_PERMISSION },
  },
]
